import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase/config';

// Analytics service for tracking user interactions
class AnalyticsService {
  // Track page views
  trackPageView = (pageName, pageTitle) => {
    if (analytics) {
      logEvent(analytics, 'page_view', {
        page_title: pageTitle,
        page_location: window.location.href,
        page_path: pageName
      });
    }
  };

  // Track chat interactions
  trackChatInteraction = (action, messageType = null) => {
    if (analytics) {
      logEvent(analytics, 'chat_interaction', {
        action: action, // 'send_message', 'receive_response', 'start_chat', 'end_chat'
        message_type: messageType, // 'text', 'question', etc.
        timestamp: new Date().toISOString()
      });
    }
  };

  // Track contact form submissions
  trackContactFormSubmission = (success = true) => {
    if (analytics) {
      logEvent(analytics, 'contact_form_submit', {
        success: success,
        timestamp: new Date().toISOString()
      });
    }
  };

  // Track file downloads (like resume PDF)
  trackFileDownload = (fileName, fileType) => {
    if (analytics) {
      logEvent(analytics, 'file_download', {
        file_name: fileName,
        file_type: fileType,
        timestamp: new Date().toISOString()
      });
    }
  };

  // Track user engagement events
  trackEngagement = (eventName, eventData = {}) => {
    if (analytics) {
      logEvent(analytics, eventName, {
        ...eventData,
        timestamp: new Date().toISOString()
      });
    }
  };

  // Track search events (if you have search functionality)
  trackSearch = (searchTerm, results = null) => {
    if (analytics) {
      logEvent(analytics, 'search', {
        search_term: searchTerm,
        results_count: results,
        timestamp: new Date().toISOString()
      });
    }
  };

  // Track custom events
  trackCustomEvent = (eventName, eventParameters = {}) => {
    if (analytics) {
      logEvent(analytics, eventName, eventParameters);
    }
  };

  // Track user session duration
  trackSessionStart = () => {
    if (analytics) {
      logEvent(analytics, 'session_start', {
        timestamp: new Date().toISOString()
      });
    }
  };

  // Track errors
  trackError = (errorMessage, errorType = 'general') => {
    if (analytics) {
      logEvent(analytics, 'error', {
        error_message: errorMessage,
        error_type: errorType,
        timestamp: new Date().toISOString()
      });
    }
  };

  // Track button clicks
  trackButtonClick = (buttonName, buttonLocation) => {
    if (analytics) {
      logEvent(analytics, 'button_click', {
        button_name: buttonName,
        button_location: buttonLocation,
        timestamp: new Date().toISOString()
      });
    }
  };

  // Track scroll depth (useful for engagement metrics)
  trackScrollDepth = (depth) => {
    if (analytics) {
      logEvent(analytics, 'scroll_depth', {
        scroll_depth: depth,
        page_location: window.location.href,
        timestamp: new Date().toISOString()
      });
    }
  };
}

// Create and export a singleton instance
const analyticsService = new AnalyticsService();
export default analyticsService;